import PropTypes from 'prop-types';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
import {Grid, Typography} from '@mui/material';

export const CommonFields = ({name}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Label
        </Typography>
        <RHFMultilingualField name={`${name}.label`} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Title
        </Typography>
        <RHFMultilingualField name={`${name}.title`} />
      </Grid>

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Description
        </Typography>
        <RHFMultilingualField name={`${name}.description`} />
      </Grid>
    </Grid>
  );
};

CommonFields.propTypes = {
  name: PropTypes.string.isRequired,
};
